import React from 'react';
import CustomButton from '../customButton';
import { Link } from 'react-router-dom';
import { Image } from 'react-bootstrap';
import profileMiniCardsCSS from './profileMiniCards.module.css';
// import Image from 'react-bootstrap/Image';
// import CartImage from '../icons/cart';

export function ProfileProductCard({ product, id, columnClass }) {

    const {name, supplier, image} = product;

    // varenummer er fjernet fra const'en over

    return(
        
        // <div className={columnClass}>
            <div className={profileMiniCardsCSS.card}>
                 <Link to={`/dokumentasjon`}>
                <div className="col-12">
                    <Image className={profileMiniCardsCSS.cardImage} fluid src={image.data.attributes.url} alt={name}/>
                </div>
                    {supplier?.data?.attributes?.name && (
                            <div className={profileMiniCardsCSS.supplier}>
                                <p>fra {supplier.data.attributes.name}</p>
                            </div>
                        )}
                    <div className={profileMiniCardsCSS.title}>
                        {name}
                    </div>
                    
                    {/* <div className="mt-4">
                        {varenummer}
                    </div> */}
                    <div className="text-center mt-auto">
                       
                            <CustomButton 
                                label="Mer informasjon"
                                className={`${profileMiniCardsCSS.cardButton} knapp`}
                            />
                    </div>
                    </Link>
            </div>
        // </div>
    )
}

export default ProfileProductCard;